import { render, staticRenderFns } from "./NumbersDash.vue?vue&type=template&id=252b5f0a&scoped=true&"
import script from "./NumbersDash.vue?vue&type=script&lang=js&"
export * from "./NumbersDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b5f0a",
  null
  
)

export default component.exports